import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 91F83E23-FD44-4277-BD91-037B3D7EB72E
 * name menu-left
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/menu-left.svg
 * tags
 * - Arrow 
 */
export const MenuLeftIcon = createSvgIcon(<><path d="M14,7L9,12L14,17V7Z" /></>, 'MenuLeftIcon');
export default MenuLeftIcon